module.exports = __webpack_public_path__ + "img/architecture-1.dee017a7.jpg";